import { createSelector } from "@reduxjs/toolkit"
import _ from "lodash"

export const selectAppIntroDataItem = createSelector(
  [state => state.app.intro.data.data, (_, alias) => alias],
  (tours, alias) => {
    return _.find(tours, { alias })
  }
)
